<script lang="ts" setup>
const props = defineProps({
  color: {
    type: String,
    default: "primary",
  },
  showSpinner: {
    type: Boolean,
    default: false,
  },
  size: {
    type: String as PropType<"sm" | "md">,
    default: "md",
  },
});

const dynamicStyles: any = {};

switch (props.color) {
  case "secondary":
    dynamicStyles[
      `active:bg-opacity-10 active:bg-secondary-tint hover:bg-opacity-10 hover:bg-secondary-shade border-secondary-default text-secondary-default`
    ] = true;
    break;
  case "google":
    dynamicStyles[
      `active:bg-opacity-10 active:bg-google-tint hover:bg-opacity-10 hover:bg-google-shade border-google-default text-google-default`
    ] = true;
    break;
  case "danger":
    dynamicStyles[
      `active:bg-opacity-10 active:bg-danger-tint hover:bg-opacity-10 hover:bg-danger-shade border-danger-default text-danger-default`
    ] = true;
    break;
  case "warning":
    dynamicStyles[
      `active:bg-opacity-10 active:bg-warning-tint hover:bg-opacity-10 hover:bg-warning-shade border-warning-default text-warning-default`
    ] = true;
    break;
  case "medium":
    dynamicStyles[
      `active:bg-opacity-10 active:bg-medium-tint hover:bg-opacity-10 hover:bg-medium-shade border-medium-default text-medium-default`
    ] = true;
    break;
  case "success":
    dynamicStyles[
      `active:bg-opacity-10 active:bg-success-tint hover:bg-opacity-10 hover:bg-success-shade border-success-default text-success-default`
    ] = true;
    break;
  case "primary":
  default:
    dynamicStyles[
      `active:bg-opacity-10 active:bg-primary-tint hover:bg-opacity-10 hover:bg-primary-shade border-primary-default  text-primary-default`
    ] = true;
    break;
}

switch (props.size) {
  case "sm":
    dynamicStyles["text-body-2 p-1"] = true;
    break;
  case "md":
    dynamicStyles["p-2"] = true;
    break;
}
</script>

<template>
  <div class="relative rounded">
    <button
      class="h-full px-4 w-full border rounded select-none flex flex-row items-center justify-center"
      :class="dynamicStyles"
    >
      <slot />
    </button>
    <transition>
      <div
        v-if="showSpinner"
        class="flex rounded items-center justify-center absolute top-0 left-0 w-full h-full bg-overlay"
      >
        <icon name="svg-spinners:ring-resize" class="text-white" size="20" />
      </div>
    </transition>
  </div>
</template>

<style scoped>
.v-enter-from,
.v-leave-to {
  opacity: 0;
}

.v-enter-active,
.v-leave-active {
  transition: all 150ms ease-in;
}

.v-enter-to,
.v-leave-from {
  opacity: 1;
}
</style>
